import { useContext } from "react";
import AppStateContext from "./context";

export const useAppStateContext = () => {
    const context = useContext(AppStateContext);
    if (!context) {
        throw new Error('useAppStateContext must be used within an AppStateProvider');
    }
    return context;
};